import InviteLeadsForm from './InviteLeadsForm.component';

export default InviteLeadsForm;